import React, { useEffect } from 'react';
import { Box } from '../UI-CHAKRA/Box';
import { ANCHORS, ANCHOR_POS } from './notifications';
import { usePrescriptionStore } from '../../stores/prescriptionStore';
import { useNotificationStore } from '../../stores/notificationStore';

interface AnchorProps {
  anchorName: ANCHORS;
  children: React.ReactNode;
  position: ANCHOR_POS;
  negativeGap?: number;
  fitWidth?: boolean;
}

export const Anchor = (props: AnchorProps) => {
  const { checkIfComponentHasNotification } = useNotificationStore();
  const { prescriberConfigurations } = usePrescriptionStore();

  useEffect(() => {
    if (!prescriberConfigurations) return;

    queueMicrotask(() => {
      checkIfComponentHasNotification(props.anchorName, props.position, props.negativeGap || 0, prescriberConfigurations);
    });
  }, [prescriberConfigurations, props.anchorName, props.position, props.negativeGap, checkIfComponentHasNotification]);

  return (
    <Box
      position={'relative'}
      id={`root-anchor-${props.anchorName}`}
      borderRadius={'10px'}
      style={{ animationDelay: '1000ms', zIndex: 1 }}
      data-testid={`root-anchor-${props.anchorName}`}
      w={props.fitWidth ? 'auto' : '100%'}
      overflow={'visible'}
    >
      <Box
        id={props.anchorName}
        data-testid={props.anchorName}
        h={'0px'}
        w={'100%'}
        position={'absolute'}
        overflow={'visible'}
        pointerEvents={'none'}
        style={{ zIndex: 1 }}
      ></Box>
      {props.children}
    </Box>
  );
};
